import { StopPayment } from '@treasury/domain/stop-payments';
import { TmBaseComponent } from '@treasury/presentation';
import '@treasury/presentation/components/layout/tm-section';
import '@treasury/presentation/components/tm-footer';
import { ButtonConfig } from '@treasury/presentation/components/tm-footer.types';
import { css, html } from 'lit';
import { customElement, property } from 'lit/decorators.js';
import './readonly-stop-payment.template';

export const tagName = 'stop-payment-review-step';
@customElement(tagName)
export class StopPaymentReviewStep extends TmBaseComponent {
    @property({ type: Object })
    public stopPayment!: StopPayment;

    @property({ type: Boolean })
    public isEdit = false;

    protected render() {
        return html`
            <tm-section class="mb-2 p-6"
                ><readonly-stop-payment .stopPayment=${this.stopPayment}></readonly-stop-payment>
            </tm-section>
            ${this.renderFooter()}
        `;
    }

    protected renderFooter() {
        const buttons: ButtonConfig[] = [
            {
                text: this.isEdit ? 'Update stop payment' : 'Add stop payment',
                onClick: () =>
                    this.dispatchEvent(
                        new CustomEvent('confirm', { bubbles: true, composed: true })
                    ),
            },
        ];
        return html`<tm-footer .buttonConfig=${buttons}></tm-footer>`;
    }

    public static get styles() {
        return [
            css`
                :host {
                    display: flex;
                    flex-direction: column;
                    height: 100vh;
                }
            `,
        ];
    }
}

declare global {
    interface HTMLElementTagNameMap {
        [tagName]: StopPaymentReviewStep;
    }
}
